// src/features/merchantConfig/components/editors/BooleanEditor.jsx
//
// Two-state pill toggle (Enabled / Disabled). Commits the flipped value
// immediately - there's no in-between draft state to defer.

import React from "react";

/**
 * @param {{
 *   value: boolean | null | undefined,
 *   onCommit: (next: boolean) => void,
 *   ariaLabel: string,
 *   inputId?: string,
 * }} props
 */
export default function BooleanEditor({ value, onCommit, ariaLabel, inputId }) {
  const isOn = value === true;

  return (
    <button
      id={inputId}
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-label={ariaLabel}
      onClick={() => onCommit(!isOn)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onCommit(!isOn);
        }
      }}
      className={[
        "relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
        isOn ? "bg-green-500" : "bg-gray-300",
      ].join(" ")}
    >
      <span
        className={[
          "inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform",
          isOn ? "translate-x-5" : "translate-x-0.5",
        ].join(" ")}
        aria-hidden="true"
      />
      <span className="sr-only">{isOn ? "Enabled" : "Disabled"}</span>
    </button>
  );
}
